<script setup lang="ts">
    import { toRef, computed } from 'vue'

    import type { NumericInputDialogViewModel } from '@common/Components/NumericInputDialog'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        viewModel: NumericInputDialogViewModel
    }>()

    const emit = defineEmits<{
        (e: 'update-value', value: string | null, id: number | string | null): void
    }>()

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.isOpened)

    // ---------------- methods ----------------

    function handleFormSubmit()
    {
        const value = vm.value.value?.toString().trim() || null
        emit('update-value', value, vm.value.id)
    }

    function close()
    {
        vm.value.isOpened = false
    }
</script>


<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{vm.title}}</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <form id="numeric-input-dialog-form" @submit.prevent="handleFormSubmit">
                            <div class="form-group">
                                <label>{{vm.label}} <span v-if="vm.showValueRange" class="text-muted">(from: {{ vm.minValue != null ? vm.minValue.toString() : 'any'  }}, to: {{ vm.maxValue != null ? vm.maxValue.toString() : 'any'  }})</span></label>
                                <input type="number" class="form-control" v-model.number="vm.value" :min="vm.minValue" :max="vm.maxValue" :step="vm.step" :required="vm.valueRequired" />
                                <small>{{vm.description}}</small>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="numeric-input-dialog-form" class="btn btn-primary">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>